import { Constants } from "../../data/constants";
import { HttpService } from "../../utils/HttpService";
export class PackageAndPrivilegeService {
  constructor() {
    this.constants = new Constants();
    this.HttpService = new HttpService();
  }

  getPackagesList = async (session_id) => {
    try {
      return await this.HttpService.getJson(
        this.constants.packageAndPrivilegeServicesURLs.getPackages,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  createPackage = async (session_id, pkg) => {
    const request = {
      pkgCode: pkg.pkgCode,
      pkgName: pkg.pkgName,
      // pkgRatio: pkg.pkgRatio
    };
    try {
      return await this.HttpService.postJson(
        this.constants.packageAndPrivilegeServicesURLs.createPackage,
        request,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  editPackage = async (session_id, pkg) => {
    try {
      return await this.HttpService.putJson(
        this.constants.packageAndPrivilegeServicesURLs.editPackage,
        {
          pkgCode: pkg.pkgCode,
          pkgName: pkg.pkgName,
          // pkgRatio: pkg.pkgRatio
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  deletePackage = async (session_id, item) => {
    try {
      return await this.HttpService.deleteJson(
        this.constants.packageAndPrivilegeServicesURLs.deletePackage +
          `${item.pkgCode}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getPrivilegesList = async (session_id) => {
    try {
      return await this.HttpService.getJson(
        this.constants.packageAndPrivilegeServicesURLs.getPrivileges,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getPackagePrivilegesList = async (session_id, pkgCode) => {
    try {
      return await this.HttpService.getJson(
        this.constants.packageAndPrivilegeServicesURLs.getPackagePrivileges +
          `${pkgCode}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  addPackagePrivileges = async (session_id, pkgPrivileges) => {
    try {
      return await this.HttpService.postJson(
        this.constants.packageAndPrivilegeServicesURLs.addPackagePrivileges,
        pkgPrivileges,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
}
